import React, { useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import "./factory.css";
// import MessagesComponents from "./components/messages/messagesComponents";
import WithInactivityTimer from "../../../inactivityTimer/withActivityTimer";
import { useSnackbar } from "notistack";
import Pusher from "pusher-js";
import Sidebar from "./sidebar/sidebar";
import NavbarMobile from "../navbarMobile/navbar";
import Navbar from "../navbar/navbar";
import FactorySupport from "./support";
import FactorySettings from "./settings";
import FactoryHistory from "./history";
import FactoryMain from "./main";
import FactoryEvacuation from "./evacuation";
import FactoryDrivers from "./drivers";
import { notificationBus } from "../../../notificationBus";
import { storage } from "../../../scopedStorage";

const CustomSnackbarContent = ({ data, history }) => {
  // console.log(history);
  return (
    <div
      style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
      onClick={() => history.push("/dashboards/notification")}
    >
      <span style={{ marginRight: "10px" }}>🚀</span>
      <div>
        <strong>Alert !</strong>
        <p>{data}</p>
      </div>
    </div>
  );
};

const FactoryDashboard = ({ children }) => {
  const location = useLocation();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [titleName, setTitleName] = useState("Dashboard");
  const [open, setOpen] = useState(false);

  const [isMobile, setIsMobile] = useState(false);

  const openSidebar = () => {
    setSidebarOpen(true);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 500px)");
    setIsMobile(mediaQuery.matches);
    const handleMediaQueryChange = (event) => {
      setIsMobile(event.matches);
    };
    mediaQuery.addEventListener("change", handleMediaQueryChange);
    return () => {
      mediaQuery.removeEventListener("change", handleMediaQueryChange);
    };
  }, []);

  const factoryInfo = JSON.parse(storage.getItem("factoryInfo"));

  // Sound notification function
  const playSound = () => {
    const audio = new Audio("/notification.mp3"); // Path to your sound file
    audio.play().catch((e) => console.error("Error playing sound:", e));
  };

  useEffect(() => {
    // Old config (Monicredit-hosted websocket):
    // var pusher = new Pusher("4a2216be62f989b542473016ba7fc057", {
    //   cluster: "mt1",
    //   wsHost: "websocket.monicredit.com",
    //   wsPort: 443,
    // });
    var pusher = new Pusher("4a2216be62f989b542473016ba7fc057", {
      cluster: "mt1",
      wsHost: "switch-socket.on-forge.com",
      wsPort: 443,
      wssPort: 443,
      forceTLS: true,
      disableStats: true,
    });

    var channel = pusher.subscribe(`factory-${factoryInfo?.factory?.id}`);

    const handleSendNotification = (data) => {
      notificationBus.emit(data);
      const message = data?.message || "Hello, You have new notification !";
      playSound();
      enqueueSnackbar(
        <CustomSnackbarContent data={message} history={history} />,
        {
          // variant: "info",
          style: { backgroundColor: "#231F20", color: "white" },
          autoHideDuration: 10000, // 10000 milliseconds = 10 seconds
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        }
      );
      // console.log(data);
      // window.location.reload();
    };

    channel.bind("factory-notification", handleSendNotification);

    // Cleanup
    return () => {
      channel.unbind("factory-notification", handleSendNotification);
      channel.unsubscribe();
    };
  }, []);
  return (
    <div className="containerss">
      {isMobile ? (
        <NavbarMobile
          sidebarOpen={sidebarOpen}
          openSidebar={openSidebar}
          titleName={titleName}
        />
      ) : (
        <Navbar
          sidebarOpen={sidebarOpen}
          openSidebar={openSidebar}
          titleName={titleName}
        />
      )}
      <Sidebar closeSidebar={closeSidebar} sidebarOpen={sidebarOpen} />
      {location.pathname === "/factory" && <FactoryMain />}
      {location.pathname === "/factory/settings" && (
        <FactorySettings setTitleName={setTitleName} />
      )}
      {location.pathname === "/factory/support" && (
        <FactorySupport setTitleName={setTitleName} />
      )}
      {location.pathname === "/factory/evacuation" && (
        <FactoryEvacuation setTitleName={setTitleName} />
      )}
      {location.pathname === "/factory/history" && (
        <FactoryHistory setTitleName={setTitleName} />
      )}
       {location.pathname === "/factory/drivers" && (
        <FactoryDrivers setTitleName={setTitleName} />
      )}
    </div>
  );
};

// The factory app was importing WithInactivityTimer but never applying it —
// it never got an idle timeout at all. Wrap it like the other three
// dashboards, and use the actual factory login route (not the shared
// "/factory" gate path, which just re-runs the auth check).
export default WithInactivityTimer(FactoryDashboard, "/factoryLogin");